<ng-container *transloco="let t">
<div class="container-fluid g-0">
  <div
    class="row d-flex flex-row flex-nowrap overflow-auto scenarios-container"
  >
    @for (scenario of scenarios; track scenario.pricingScenarioId) {
      <div
        class="text-center me-1 col-sm-12 col-md-6 col-lg-4"
      >
        <scenario-card
          [scenario]="scenario"
          [index]="scenario['index']"
          [applicationId]="applicationId"
        >
        </scenario-card>
      </div>
    }
  </div>
  @if (scenarios.length == 0) {
    <div>
      <h5 class="text-center text-muted">
        <span> {{ t('portal.tasks.noSavedScenarios') }} </span>
      </h5>
    </div>
  }
</div>
</ng-container>
